/**
 * Environment variable utility that works in both Vite and Jest environments
 *
 * Note: This file uses process.env which is injected by Vite's define plugin
 * and also works in Jest/CRA environments.
 */

// Common environment variables with fallbacks
// In Vite, these are replaced at build time via vite.config.js define option
// In Jest/CRA, process.env is available directly
// Production fallback: https://api.vivyawatch.com
export const API_URL = process.env.VITE_API_URL || process.env.REACT_APP_API_URL || 'https://api.vivyawatch.com';
export const BACKEND_URL = process.env.VITE_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || 'https://api.vivyawatch.com';

